import { DrawerV2 } from '@withjoy/joykit';
import React from 'react';

export const BottomSheet = ({ isOpen, onClose, children }: { isOpen: boolean; onClose: () => void; children: React.ReactNode }) => {
  return (
    <DrawerV2
      isOpen={isOpen}
      overrides={{ Content: { props: { maxHeight: '97%', height: '97%', width: '100%', borderTopLeftRadius: 4, borderTopRightRadius: 4, userSelect: 'text' } } }}
      onClose={onClose}
      anchor="bottom"
      stickyBehavior="header-footer"
      size="auto"
      useBackdrop
      disableCloseOnEscapeKeyClick
      disableCloseOnOutsideClick
      disableFocusLockRemoveScroll
    >
      {children}
    </DrawerV2>
  );
};
